import { useState, useEffect } from "react";
import {
  getSentHistory,
  clearSentHistory,
  type SentEmailRecord,
} from "../../lib/email-storage.ts";
import { toast } from "../Toast.tsx";
import { useConfirm } from "../useConfirm.tsx";
import { fmtDate } from "../../lib/ui.ts";

export function SentHistorySection() {
  const [history, setHistory] = useState<SentEmailRecord[]>([]);
  const { ask, dialog } = useConfirm();

  function load() {
    setHistory(getSentHistory());
  }

  useEffect(() => {
    load();
  }, []);

  function handleClear() {
    ask({
      title: "Clear sent email history?",
      message: "This will clear your local audit log of sent emails. It does not un-send any emails.",
      confirmLabel: "Clear history",
      danger: true,
      run: () => {
        clearSentHistory();
        load();
        toast("Sent history cleared.", true);
      },
    });
  }

  return (
    <div className="card card-pad">
      <div className="section-head">
        <div>
          <h3>Sent Emails History</h3>
          <p className="hint">
            Audit log of emails dispatched from the admin app to users ({history.length} total).
          </p>
        </div>

        {history.length > 0 && (
          <button type="button" className="btn btn-ghost btn-sm" onClick={handleClear}>
            Clear history
          </button>
        )}
      </div>

      <div className="table-wrap mt-3">
        <table className="data-table">
          <thead>
            <tr>
              <th>Recipient</th>
              <th>Subject</th>
              <th>Template</th>
              <th>Status</th>
              <th>Sent At</th>
            </tr>
          </thead>
          <tbody>
            {history.length === 0 ? (
              <tr>
                <td colSpan={5} className="table-empty">
                  No outreach emails have been sent yet.
                </td>
              </tr>
            ) : (
              history.map((item) => (
                <tr key={item.id}>
                  <td>
                    <div className="cell-title">{item.recipientName ?? "—"}</div>
                    <div className="cell-sub mono muted">{item.recipientEmail}</div>
                  </td>
                  <td>
                    <span className="mono text-sm">{item.subject}</span>
                  </td>
                  <td>
                    <span className="badge badge-neutral">{item.templateName}</span>
                  </td>
                  <td>
                    {item.status === "sent" ? (
                      <span className="badge badge-ok">Sent</span>
                    ) : (
                      <span className="badge badge-danger" title={item.error ?? undefined}>
                        Failed
                      </span>
                    )}
                  </td>
                  <td className="muted tnum">{fmtDate(item.sentAt)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {dialog}
    </div>
  );
}
